export function preload(component) {
    if (isPreloadable(component)) {
        component.preload();
    }
}
function isPreloadable(component) {
    return "preload" in component && typeof component.preload === "function";
}
